import { useQuery } from "@tanstack/react-query";
import { Disclosure } from "@/components/Disclosure";
import { sendAjaxRequest } from "@/ts/api/comunicacion";
import { Constantes } from "@/ts/constantes";
import { TablaPedidos } from "./TablaPedidos";
import { HorizontalTabs } from "@/components/Tabs";
import { useState } from "react";
import { Breadcrumb } from "@/components/Breadcrumb";
import { Loading, QueryError } from "@/components/Loading/Loading";
import "./LanzarCiclos.css";

export function LanzarCiclosPage() {
	const [filtroMedio, setFiltroMedio] = useState("");
	const [filtroEmpaquetado, setFiltroEmpaquetado] = useState("");
	const [filtroEnviado, setFiltroEnviado] = useState("");

	return (
		<div id="content" className="content" >
			<title>Piher | Lanzamiento de ciclos</title>

			<Breadcrumb
				sectionTitle="Pedidos Venta"
				links={[
					{ label: "Pedidos Venta", active: true }
				]}
			/>


			<div className="box-shadow panel-box panel-info" style={{ display: "none" }}>
				<h4><strong>Info</strong></h4>
				Listado de ciclos de pedidos de venta que se gestiona administración. Existe un panel de filtros donde poder filtrar los ciclos según los diferentes criterios.
				Desde la siguiente pantalla se gestiona el lanzamiento de ciclos, asi como la post-gestión de ver si estan los pedidos empaquetados y marcar los albaranes como enviados
			</div>


			<Disclosure style={{ marginBottom: 20 }}>
				{/* First element is the summary, second is the content */}
				<h4 className="panel-title panel-heading senalar">
					Filtro
				</h4>
				<AcordeonFiltros
					filtroMedio={filtroMedio}
					setFMedio={setFiltroMedio}
					filtroEmpaquetado={filtroEmpaquetado}
					setFEmpaquetado={setFiltroEmpaquetado}
					filtroEnviado={filtroEnviado}
					setFEnviado={setFiltroEnviado}
				/>
			</Disclosure>

			<TablaConTabs
				filtroMedio={filtroMedio}
				filtroEmpaquetado={filtroEmpaquetado}
				filtroEnviado={filtroEnviado}
			/>


			{/* <ModalPedidoEmpaquetado /> */}
		</div>
	);
}


interface PropsAcordeonFiltros {
	readonly filtroMedio: string;
	readonly setFMedio: (value: string) => void;
	readonly filtroEmpaquetado: string;
	readonly setFEmpaquetado: (value: string) => void;
	readonly filtroEnviado: string;
	readonly setFEnviado: (value: string) => void;
}
function AcordeonFiltros(props: PropsAcordeonFiltros) {
	const { data: medios, isLoading, isError } = useMedios();

	if (isLoading) return <Loading />;
	if (isError) return <div>Error al cargar los transportistas</div>;

	return (
		<div className="inputContainerGrid" style={{ padding: 30 }} role="tabpanel">
			<div className="containerLbl">
				<label style={{ fontSize: 17 }}>Transportistas: </label>
				<select className="form-control" value={props.filtroMedio} onChange={event => { props.setFMedio(event.target.value); }}>
					<option value="">Sin Filtrar</option>
					{medios?.map(linea => (
						<option value={linea.idMedio} key={linea.idMedio}>
							{linea.idMedio} - {linea.nombreMedio}
						</option>
					))}
				</select>
			</div>
			<div className="containerLbl">
				<label style={{ fontSize: 17 }}>Empaquetado: </label>
				<select className="form-control" value={props.filtroEmpaquetado} onChange={event => { props.setFEmpaquetado(event.target.value); }}>
					<option value="">Sin Filtrar</option>
					<option value="true">Empaquetado</option>
					<option value="false">No empaquetado</option>
				</select>
			</div>
			<div className="containerLbl">
				<label style={{ fontSize: 17 }}>Enviado: </label>
				<select className="form-control" value={props.filtroEnviado} onChange={event => { props.setFEnviado(event.target.value); }}>
					<option value="">Sin Filtrar</option>
					<option value="true">Enviado</option>
					<option value="false">No enviado</option>
				</select>
			</div>
		</div>
	);
}


interface PropsTablaConTabs {
	readonly filtroMedio: string;
	readonly filtroEmpaquetado: string;
	readonly filtroEnviado: string;
}
function TablaConTabs(props: PropsTablaConTabs) {
	const [cicloVisualizado, setCicloVisualizado] = useState("null");
	const { data: ciclos, error, isPending } = useCiclos();


	if (error) return <QueryError error={error} fallback="Error al cargar los ciclos" />;

	const ciclosMapped = !ciclos?.data ? [] : Object.entries(ciclos.data).map(([idCiclo, ciclo]) => {
		const tituloCiclo = ciclo.idCiclo == null ? "Sin Ciclo" : `Ciclo ${idCiclo} - Prioridad: ${Prioridades[ciclo.prioridad]}`;
		return [tituloCiclo, idCiclo] as [string, string];
	});

	// eslint-disable-next-line @typescript-eslint/dot-notation -- For "null" it doesnt
	const ciclo = !ciclos?.data ? null : (cicloVisualizado === "null" ? ciclos.data["null"] : ciclos.data[Number(cicloVisualizado)]);
	const pedidosFiltrados = !ciclo ? [] : ciclo.pedidos
		.filter(pedido => (props.filtroMedio === "" || pedido.idTransporte.toString() === props.filtroMedio))
		.filter(pedido => (props.filtroEmpaquetado === "" || pedido.empaquetado.toString() === props.filtroEmpaquetado))
		.filter(pedido => (props.filtroEnviado === "" || pedido.enviado.toString() === props.filtroEnviado));



	return (
		<div className="tabsCiclos">
			{Constantes.existenCiclos ? (
				<HorizontalTabs options={ciclosMapped} value={cicloVisualizado} setValue={setCicloVisualizado} />
			) : null}

			<div className="">
				<div className="table-responsive">
					<TablaPedidos data={pedidosFiltrados} cicloActual={ciclo} />
				</div>
			</div>


		</div>
	);
}



function useCiclos() {
	return useQuery({
		queryKey: ["getCiclos"],
		queryFn: () => {
			return sendAjaxRequest<{ data: Record<string, CicloVenta>; }>("GET", "/api/v1/getCiclosConPedidos");
		},
	});
}




enum Prioridades {
	"Tiempo Real" = 1,
	"Alta" = 2,
	"Normal" = 3,
	"Menor" = 4,
	"Baja" = 5,
}


function useMedios() {
	return useQuery({
		queryKey: ["getMedios"],
		queryFn: () => sendAjaxRequest<Medio[]>("GET", "/api/v1/getMedios"),
	});
}




interface Medio {
	idMedio: string,
	nombreMedio: string,
}
export interface CicloVenta {
	idCiclo: number | null;
	prioridad: number;
	pedidos: PedidoVenta[];
}
export interface PedidoVenta {
	idTransporte: number;
	nombreTransporte: string;
	idCliente: number;
	nombreCliente: string;
	idPedido: number;
	importe: number;
	// peso_total: number;
	fechaPedido: number;
	empaquetado: boolean;
	enviado: boolean;
}